var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { action, makeObservable, observable, runInAction } from 'mobx';
import { BaseSingletonService, Singleton } from './service.base';
import { UIOpenService } from './service.ui';
import { EApiUrl } from '~/tools/api/types';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { ModelUser } from '~/models';
import { plainToInstance } from 'class-transformer';
export let ServiceUser = class ServiceUser extends BaseSingletonService {
    openDialogSvc;
    adminUser;
    constructor(openDialogSvc) {
        super();
        this.openDialogSvc = openDialogSvc;
        makeObservable(this, {
            adminUser: observable,
            getAdminUser: action,
        });
    }
    getAdminUser(userId) {
        return new MobxQuery({
            queryFn: (() => api.get(`${EApiUrl.adminUsers}/${userId}`).then(response => {
                runInAction(() => (this.adminUser = plainToInstance(ModelUser, response.data.model)));
            })),
        }).query();
    }
};
ServiceUser = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceUser);
